export default __webpack_public_path__ + "static/media/kaduna-terminal2.48bf4f58.png";